export const LINKS = {
    LEARNING_CARDS_SERVICE: `/learning-cards`,
    SSO_SERVICE: `/sso`,
};
